import { render } from "./PropertyReservation.vue?vue&type=template&id=f2a93612"
import script from "./PropertyReservation.vue?vue&type=script&lang=js"
export * from "./PropertyReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__